import { Button } from '@onwardtravelsolutions/package-react/Components';

type PrimaryButtonProps = {
    children: React.ReactNode;
    className?: string;
} & (
        | (React.AnchorHTMLAttributes<HTMLAnchorElement> & { type?: never })
        | (React.ButtonHTMLAttributes<HTMLButtonElement> & { href?: never })
    );

export default function PrimaryButton({
    children,
    className = null,
    ...rest
}: PrimaryButtonProps) {
    return (
        <Button
            className={`px-6 py-3 rounded font-semibold text-base md:text-lg inline-block transition cursor-pointer bg-primary hover:bg-[#eba800] text-gray-900 ${className}`}
            {...rest}
        >
            {children}
        </Button>
    );
}
